// Converts English digits to Farsi digits
export function toFarsiNumber(str) {
  return String(str).replace(/[0-9]/g, d =>
    String.fromCharCode(d.charCodeAt(0) + 1728)
  );
}

// Formats a number with commas and Farsi digits
export function formatFarsiPrice(value) {
  if (value === undefined || value === null || value === '') return '';
  // Remove non-digit chars, except dot
  let num = String(value).replace(/[^\d.]/g, '');
  if (!num) return '';
  // Add commas
  num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return toFarsiNumber(num);
}
